module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "login-container boxed-login",
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.signin($event)
      }
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "col-md-4 col-md-offset-4 col-sm-4 col-sm-offset-4"
  }, [_c('div', {
    staticClass: "login-form-container"
  }, [_vm._m(0), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "pointer"
  }, [_c('a', {
    staticClass: "gary",
    on: {
      "click": function($event) {
        _vm.goToDashboard()
      }
    }
  }, [_vm._v("返回首頁")])])])])]), _vm._v(" "), _c('footer', {
    staticClass: "login-page-footer"
  })]), _vm._v(" "), _c('simplert', {
    ref: "simplert",
    attrs: {
      "useRadius": true,
      "useIcon": true
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "j-forms",
    attrs: {
      "id": "forms-login",
      "novalidate": "novalidate"
    }
  }, [_c('div', {
    staticClass: "login-form-header"
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('img', {
    staticClass: "logo-pic",
    attrs: {
      "src": require("../../assets/img/logo3.png"),
      "alt": "logo"
    }
  })])]), _vm._v(" "), _c('h3', [_vm._v("邀請連結驗證中....請稍等")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dfc0c958","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Users/AcceptInvitation.vue
// module id = 713
// module chunks = 4